import { useState } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./App.css";
import { HomeLandingPage } from "./Components/Home/HomeLandingPage/HomeLandingPage";
import { ContactUs } from "./Components/ContactUs/ContactUs";
import { AboutUs } from "./Components/AboutUs/AboutUs";
import { Services } from "./Components/Services/Services";
import { OnlineCourses } from "./Components/Courses/OnlineCourses/OnlineCourses";
import { OnlineViewDetail } from "./Components/Courses/OnlineViewDetail/OnlineViewDetail";
import { OfflineCourses } from "./Components/Courses/OfflineCourses/OfflineCourses";
import { Career } from "./Components/Career/Career";
import { LoggedInLandingPage } from "./Components/LoggedInScreens/LoggedInLandingPage/LoggedInLandingPage";
import { Notification } from "./Components/LoggedInScreens/Notification/Notification";
import { EditProfile } from "./Components/LoggedInScreens/EditProfile/EditProfile";
import { MyCoursesMoreInfo } from "./Components/LoggedInScreens/MyCoursesMoreInfo/MyCoursesMoreInfo";
import { PurchaseHistory } from "./Components/LoggedInScreens/PurchaseHistory/PurchaseHistory";
import { Login } from "./Components/Login/Login";
import { LoginOTP } from "./Components/LoginOTP/LoginOTP";
import { Register } from "./Components/Register/Register";
import { ZoomSchedule } from "./Components/LoggedInScreens/ZoomSchedule/ZoomSchedule";
import { MyCourseCard } from "./Components/LoggedInScreens/CourseCard/CourseCard";
import { AllCourses } from "./Components/LoggedInScreens/AllCourses/AllCourses";
import { CourseViewDetails } from "./Components/LoggedInScreens/CourseViewDetails/CourseViewDetails";
import { Certificate } from "./Components/LoggedInScreens/Certificate/Certificate";
import { WebinarLanding } from "./Components/Webinar/WebinarLanding/WebinarLanding";
// import { WebinarView } from "./Components/Webinar/WebinarView/WebinarView";
import { Routes, Route, useLocation } from "react-router-dom";
import ZoomPage from "./Components/LoggedInScreens/ZoomSchedule/ZoomPage";
import WebinarZoom from "./Components/WebinarZoom/WebinarZoom";
import MCQ from "./Components/MCQ/MCQ";
import MCQTopic from "./Components/MCQ/MCQTopic";
import MCQQuestions from "./Components/MCQ/MCQQuestions";
import MCQResult from "./Components/MCQ/MCQResult";
import PageNotFound from "./Components/404/404";
import FindCertificate from "./Components/E_Certificate/FindCertificate";
import ViewCertifivcate from "./Components/E_Certificate/ViewCertifivcate";
import { PopUpAlert } from "./Components/PopUpAlert/PopUpAlert";
import Chatbot from "./Components/chatbot/chatbot";
import { TermsConditions } from "./Components/TermsConditions";
import { PrivacyPolicy } from "./Components/PrivacyPolicy";

function App() {
  const location = useLocation();

  const isWebinarRoute = location.pathname.startsWith("/webinar/");

  const [isAlertSubmit, setIsAlertSubmit] = useState(false);

  function checkCookie() {
    let isAlert = document.cookie.split(";");
    for (let i of isAlert) {
      let alertKey = i.split("=");

      let aKey = alertKey[0].trim();
      if (aKey === "isAlert") {
        return parseInt(alertKey[1]);
      }
    }

    return 0;
  }

  async function closeAlert() {
    setIsAlertSubmit(true);
    setTimeout(() => {
      setIsAlertSubmit(false);
    }, 1000 * 60);
  }


  return (
    <Provider store={store}>
      <>
        {!checkCookie() &&
          !isAlertSubmit &&
          !isWebinarRoute && (
            <PopUpAlert isSubmit={setIsAlertSubmit} closeAlert={closeAlert} />
          )}
        <Chatbot />
        {/* <button onClick={remov}>SetCooie</button> */}

        <Routes>
          <Route exact path="*" element={<PageNotFound />} />
          <Route exact path="/" element={<HomeLandingPage />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/onlinecourses" element={<OnlineCourses />} />
          <Route
            path="/onlinecourses/viewdetails/:courseId/:courseName"
            element={<OnlineViewDetail />}
          />
          <Route path="/offlinecourses" element={<OfflineCourses />} />
          <Route path="/career" element={<Career />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/login" element={<Login />} />
          <Route path="/mcq" element={<MCQ />} />
          <Route path="/mcq/topics/:collectionId" element={<MCQTopic />} />
          <Route path="/mcq/result/:resultId" element={<MCQResult />} />
          <Route
            path="/mcq/test/:collectionId/:topic"
            element={<MCQQuestions />}
          />
          <Route path="/verify/e_certificate" element={<FindCertificate />} />
          <Route
            path="/view/e_certificate/:certificateId"
            element={<ViewCertifivcate />}
          />
          <Route path="/loginotp" element={<LoginOTP />} />
          <Route path="/register/:mobileNumber" element={<Register />} />
          <Route path="/webinar/:webinarId" element={<WebinarLanding />} />
          {/* <Route path="/webinarview" element={<WebinarView />} /> */}
          <Route path="webinar/user/join/:userId" element={<WebinarZoom />} />

          <Route path="/dashboard" element={<LoggedInLandingPage />}>
            <Route path="schedule/:courseId" element={<ZoomSchedule />} />
            <Route path="mycourses" element={<MyCourseCard />} />
            <Route path="/dashboard/zoompage" element={<ZoomPage />} />
            <Route path="/dashboard/allcourses" element={<AllCourses />} />
            <Route path="/dashboard/notification" element={<Notification />} />
            <Route path="/dashboard/editprofile" element={<EditProfile />} />
            <Route
              path="/dashboard/viewdetails/:courseId"
              element={<CourseViewDetails />}
            />
            <Route
              path="/dashboard/mycoursemoreinfo/:courseId"
              element={<MyCoursesMoreInfo />}
            />
            <Route
              path="/dashboard/purchasehistory"
              element={<PurchaseHistory />}
            />
            <Route path="/dashboard/certificate" element={<Certificate />} />
          </Route>
        </Routes>
      </>
    </Provider>
  );
}

export default App;
